/* @flow */
import * as React from 'react';
import TableRow from 'components/TableRow.jsx';
import Organization from 'entities/Organization';
import { withRouter } from 'app/context/Router.jsx';

type Props = {
  inGroupView?: ?boolean,
  disabled: boolean,
  schools: *,
  router: *,
};

class AdminSchoolTableBody extends React.Component<Props> {
  go = (school: Organization) => {
    const path = this.props.inGroupView ? 'organizations' : 'admin/schools';
    this.props.router.push({ pathname: `/${path}/${school.id}` });
  };

  render() {
    const rows = this.props.schools.map(school => {
      const statistics = school.statistics;
      const onClick = this.props.disabled ? undefined : () => this.go(school);

      return (
        <TableRow hoverable={!this.props.disabled} key={school.id} onClick={onClick}>
          <td>{school.name}</td>
          <td>{statistics && statistics.teacher_count}</td>
          <td>{statistics && statistics.subscriber_count}</td>
          <td>{statistics && statistics.class_count}</td>
          <td>{school.paidAt ? 'School Plan' : 'Unpaid'}</td>
        </TableRow>
      );
    });

    return <tbody>{rows}</tbody>;
  }
}

export { AdminSchoolTableBody };
export default withRouter(AdminSchoolTableBody);
